<div class="header">
    <span class="title left">
       <div class="airline">
          <img class="airline-logo" [src]="flightSegment.marketing_carrier.logo_symbol_url" alt="" style="left: 0px;">
          <div class="airline-name">{{ flightSegment.marketing_carrier.name }} &nbsp;</div>
       </div>
    </span>
    <div class="title right">{{ flightSegment.operating_carrier.flight_number }}&nbsp;</div>
    <div class="title right" *ngIf="flightSegment.marketing_carrier.name !== flightSegment.operating_carrier.name">| {{ 'flightsPage.result.operatedBy' | i18n }} {{ flightSegment.operating_carrier.name }}</div>
 </div>

<div class="leg-segment">
    <div class="time-line">
    </div>

    <div class="leg-details">

        <div class="segment">
            <span>{{ flightSegment.departing_at.time }} &nbsp;</span>
            <span class="text">{{ flightSegment.origin.iata_code }}</span>
        </div>
            <span>{{ parseDuration(flightSegment.duration) }}</span>

        <div class="segment">
            <span>{{ flightSegment.arriving_at.time }} &nbsp;</span>
            <span class="text">{{ flightSegment.destination.iata_code }}</span>
        </div>
    </div>
</div>

<div class="connection-summary" *ngIf="flightSegment.connectionTime">
   <span>{{ parseDuration(flightSegment.connectionTime) }} {{ 'flightsPage.result.connection' | i18n }}</span>
</div>